import { render, staticRenderFns } from "./AdminStitchesEditScreen.vue?vue&type=template&id=4c23d89c&scoped=true&"
import script from "./AdminStitchesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminStitchesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23d89c",
  null
  
)

export default component.exports